import * as React from 'react'

import { TemplateSelector } from './template-selector'
import { Templates } from '../../../dashboard'

export const EmptyState = ({
  templates,
  onSelectTemplate,
}: {
  templates: Templates['templates']['items']
  onSelectTemplate: TemplateSelector['onClick']
}) => {
  return (
    <div className="flex flex-1 flex-col justify-center rounded-2xl border border-dark-border-solid bg-dark-base px-28 xl:px-40 py-16">
      <h5 className="mb-3 text-center text-lg font-medium leading-[22px]">
        Let's create your first repo
      </h5>
      <p className="mb-7 xl:mb-10 text-center text-sm leading-4 text-dark-faint">
        Start blank or choose one of our templates
      </p>

      <div className="mx-auto flex w-full max-w-[353px] flex-col space-y-3">
        <TemplateSelector onClick={onSelectTemplate} template={null} />

        <h6 className="!mt-4 xl:!mt-6 text-xs xl:text-sm font-medium">
          Templates
        </h6>
        {templates.map((template) => (
          <React.Fragment key={template._id}>
            <TemplateSelector onClick={onSelectTemplate} template={template} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
